/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
 */
export interface GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'resourceScope': GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'resourceId': string;
    /**
     * 
     * @type {string}
     * @memberof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInner
     */
    'role': GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum;
}

export const GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum = {
    account: 'USER_ACCOUNT',
    accountGroup: 'USER_ACCOUNT_GROUP',
    accountAll: 'USER_ACCOUNT_ALL'
} as const;

export type GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum = typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum[keyof typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerResourceScopeEnum];
export const GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum = typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum[keyof typeof GetRolesWithTopRelatedResourcesByOrganizationId200ResponseInnerRoleEnum];


